<template>
  <div>
    <Header/>
    <Navigationzj ref="child"/>
    <div class="w1200">
      <div class="channel-l">
        <div>
          <ul class="shopping-li">
            <li v-for="(item,index) in cateGroyMsg" :key="index" :class='["channel-li-li",on_index == item.id ? "on" : "",cateGroyMsg.length == index+1 ? "li-more" : ""]' @click="giton(item, index)">
              <span class="channel-li-li-border">
                <i class="icon-cog"></i>
                <span class="firstLevel">{{ item.title }}</span>
                <span class="glyphicon-right"></span>
                <span class="hover-icon-right"></span>
              </span>
            </li>
          </ul>
        </div>
        <div class="personal-favarite">
          <span><strong>知名品牌</strong></span>
          <router-link class="pf-more" :to="{path: '/Brand'}">更多 &gt;</router-link>
        </div>
        <div class="partners-channel">
          <ul>
            <li v-for="(item,index) in FamousBrandsList.slice(0,12)" :key="index">
              <router-link :to="{path:'/Ppxq',query:{ bid:item.id }}" target="_blank" :title="item.title">
                <img v-real-img="item.img" src="../../assets/images/zwtp.jpg" height="55" :alt="item.title" :title="item.title"/>
              </router-link>
            </li>
          </ul>
        </div>
      </div>
      <div class="channel-r">
        <div>
          <div class="shielter"></div>
          <div class="catList" v-for="(item,index) in cateGroyMsgChlidren" :key="index">
            <div class="cat-title clearfix">
              <div class="cat-title-name">
                <router-link :to="{path:'/Classify',query:{ parent_id:item.id }}" :title="item.title">{{ item.title }}</router-link>
              </div>
              <div class="mid-border"></div>
            </div>
            <div class="clearfix">
              <div class="catNodes" v-for="(items,index) in item.children" :key="index">
                <div class="nodeImg">
                  <router-link :to="{path:'/Goods',query:{ cid:items.id,cgid:items.cgid, title: items.title }}" :title="items.title">
                    <el-image
                      :src="items.imgpath"
                      fit="fill"
                      style="width:80px;height:80px;border-radius: 7px;"
                      >
                      <div slot="error" class="image-slot">
                        <img src="../../assets/images/zwtp.jpg"/>
                      </div>
                    </el-image>
                    <i v-if="items.is_recommend == 1" class="left-top icon-category-hot"></i>
                  </router-link>
                </div>
                <div class="node-title">
                  <router-link :to="{path:'/Goods',query:{ cid:items.id }}" :title="items.title" class="luotitle">{{ items.title }}</router-link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
    <Footer/>
  </div>
</template>
<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'
import Navigationzj from '@/components/Navigationzj'
import { mapGetters } from 'vuex'
import brand from '@/api/brand'
import cate from '@/api/createGroy'

export default {
  name: 'Sitemap',
  components: {
    Header,
    Navigationzj,
    Footer
  },
  data () {
    return {
      cid: this.$route.query.grand_id,
      sid: this.$route.query.parent_id,
      cateGroyMsg: [],
      cateGroyMsgChlidren: [],
      on_index: '',
      FamousBrandsList: [],
      thispcNavigation: []
    }
  },
  computed: {
    ...mapGetters([
      'Navigation',
      'current_user'
    ]),
    getNavigation () {
      return this.thispcNavigation
    },
    getGrandId () {
      return this.$route.query.grand_id
    },
    getParentId () {
      return this.$route.query.parent_id
    }
  },
  watch: {
    getNavigation (newval, oldval) {
      if (this.cid) {
        for (var i = 0; i < newval.length; i++) {
          if (parseInt(this.cid) === newval[i].id) {
            this.cateGroyMsg = JSON.parse(JSON.stringify(newval[i].children))
            this.cateGroyMsgChlidren = JSON.parse(JSON.stringify(newval[i].children))
            this.giton(newval[i].children[0])
          }
        }
      } else if (this.sid) {
        for (var ii = 0; ii < newval.length; ii++) {
          for (var j = 0; j < newval[ii].children.length; j++) {
            if (parseInt(this.sid) === newval[ii].children[j].id) {
              this.cid = newval[ii].id
              this.getCateGroyMsg(this.cid)
              this.giton(this.thispcNavigation[ii].children[j], j)
            }
          }
        }
      }
    },
    getGrandId (newval, oldval) {
      this.getCateGroyMsg(newval)
    },
    getParentId (newval, oldval) {
      if (this.thispcNavigation.length > 0) {
        for (var i = 0; i < this.thispcNavigation.length; i++) {
          for (var j = 0; j < this.thispcNavigation[i].children.length; j++) {
            if (parseInt(newval) === this.thispcNavigation[i].children[j].id) {
              this.cid = this.thispcNavigation[i].id
              this.getCateGroyMsg(this.cid)
              this.giton(this.thispcNavigation[i].children[j], j)
            }
          }
        }
      }
    }
  },
  mounted () {
    this.category_pc_list()
    this.getFamousBrands()
  },
  methods: {
    category_pc_list () {
      cate.category_pc_list().then(res => {
        this.thispcNavigation = JSON.parse(JSON.stringify(this.Navigation))
        console.info(this.thispcNavigation)
        if (this.thispcNavigation) {
          this.thispcNavigation[0].children[2].children = res.items
          this.thispcNavigation[0].children[0].children = res.items2
          this.thispcNavigation[0].children[3].children = res.items3
          this.thispcNavigation[0].children[4].children = res.items4
        }
        if (this.cid) {
          this.getCateGroyMsg(this.cid)
        } else if (this.sid) {
          if (this.thispcNavigation.length > 0) {
            for (var i = 0; i < this.thispcNavigation.length; i++) {
              for (var j = 0; j < this.thispcNavigation[i].children.length; j++) {
                if (parseInt(this.sid) === this.thispcNavigation[i].children[j].id) {
                  this.cid = this.thispcNavigation[i].id
                  this.getCateGroyMsg(this.cid)
                  this.giton(this.thispcNavigation[i].children[j], j)
                }
              }
            }
          }
        }
      })
    },
    getCateGroyMsg (cid) {
      this.$refs.child.isShow = false
      if (this.thispcNavigation.length > 0) {
        for (var i = 0; i < this.thispcNavigation.length; i++) {
          if (parseInt(cid) === this.thispcNavigation[i].id) {
            this.cateGroyMsg = JSON.parse(JSON.stringify(this.thispcNavigation[i].children))
            this.cateGroyMsgChlidren = JSON.parse(JSON.stringify(this.thispcNavigation[i].children))
            this.giton(this.cateGroyMsg[0])
          }
        }
      }
    },
    giton (item, index) {
      this.on_index = item.id
      var arr = []
      if (Number.isInteger(index)) {
        for (var i = 0; i < this.cateGroyMsgChlidren.length; i++) {
          if (this.on_index !== this.cateGroyMsgChlidren[i].id) {
            arr.push(this.cateGroyMsgChlidren[i])
          }
        }
        arr.unshift(item)
        this.cateGroyMsgChlidren = arr
      }
    },
    getFamousBrands () {
      brand.getFamousBrands().then(res => {
        this.FamousBrandsList = res.items
      })
    }
  }
}
</script>
<style scoped>
a {
  text-decoration: none;
  color: #333;
}
.w1200 .channel-l {
  width: 230px;
  height: auto;
  float: left;
}
.w1200 .channel-l .shopping-li {
  border-bottom: 1px solid #5178b5;
  position: relative;
  width: 230px;
  /* overflow-y: auto;
  max-height: 500px; */
}
/* .w1200 .channel-l .shopping-li::-webkit-scrollbar {
  width: 1px;
  height: 1px;
}
.w1200 .channel-l .shopping-li::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #c1c1c1;
}
.w1200 .channel-l .shopping-li::-webkit-scrollbar-track {
  border-radius: 10px;
  background: #ededed;
} */
.w1200 .channel-l .shopping-li li.on {
  background-color: #5178b5;
}
.w1200 .channel-l .channel-li-li {
  border-left: 1px solid #5178b5;
  border-right: 1px solid #5178b5;
  cursor: pointer;
  height: 34px;
  line-height: 1;
  padding-left: 0;
  transition: padding-left 0.3s ease 0s;
}
.w1200 .channel-l .channel-li-li-border {
  border-bottom: 1px solid #eee;
  display: block;
  height: 100%;
  margin: 0 10px;
}
.w1200 .channel-l .channel-li-li .icon-cog {
  background: url(../../assets/images/workss.png) no-repeat;
  background-size: 100%;
  float: left;
  height: 14px;
  margin: 10px 8px 10px 0;
  overflow: hidden;
  width: 14px;
}
.w1200 .channel-l .shopping-li span.firstLevel {
  color: #333;
  display: inline-block;
  font-size: 14px;
  padding-top: 10px;
}
.w1200 .channel-l .shopping-li li.on span.firstLevel {
  color: #fff;
}
.channel-li-li .glyphicon-right {
  float: right;
  position: relative;
  top: 10px;
  width: 15px;
  height: 15px;
  background: url(../../assets/images/zp_62.png) no-repeat;
}
.w1200 .channel-l .channel-li-li:hover span {
  color: #5178b5;
}
.channel-li-li:hover .hover-icon-right {
  display: block;
}
.channel-li-li.on:hover .hover-icon-right {
  display: none;
}
.channel-li-li .hover-icon-right {
  display: none;
  float: right;
  position: relative;
  top: 10px;
  left: 15px;
  width: 15px;
  height: 15px;
  background: url(../../assets/images/zp_49.png) no-repeat;
}
.w1200 .channel-l .personal-favarite {
  margin-top: 30px;
}
.w1200 .channel-l .shopping-li .li-more .channel-li-li-border {
  border-bottom: 0;
}
.w1200 .channel-l .channel-li-li-border {
  border-bottom: 1px solid #eee;
  display: block;
  height: 100%;
  margin: 0 10px;
}
.w1200 .channel-l .pf-more {
  float: right;
  font: 12px;
}
.w1200 .channel-l .partners-channel ul {
  margin-right: -1px;
  overflow: hidden;
  padding-left: 1px;
  padding-top: 1px;
}
.w1200 .channel-l .partners-channel li {
  border: 1px solid #fff;
  /* border-bottom: 1px dashed #cccccc; */
  border: 1px solid #cccccc;
  cursor: pointer;
  float: left;
  height: 60px;
  text-align: center;
  width: 105px;
  padding-left: 5px;
  margin: 3px 3px 0 0;
}
.w1200 .channel-r {
  width: 925px;
  height: auto;
  margin-left: 45px;
  float: left;
}
.w1200 .channel-r .shielter {
  margin-top: 25px;
  margin-bottom: 15px;
}
.w1200 .channel-r .catList {
    margin-bottom: 15px;
}
.w1200 .channel-r .cat-title {
  font-size: 14px;
  font-weight: normal;
  line-height: 14px;
  margin: 0 0 0 10px;
  position: relative;
}
.w1200 .channel-r .cat-title .cat-title-name {
  background-color: #fff;
  padding-right: 8px;
  position: absolute;
  font-size: 14px;
  font-weight: bold;
}
.w1200 .channel-r .cat-title .mid-border {
  border-top: 1px solid #ddd;
  display: inline-block;
  vertical-align: middle;
  width: 100%;
}
.w1200 .channel-r .catNodes {
  cursor: pointer;
  float: left;
  height: 110px;
  margin: 10px 15px 5px 0;
  width: 100px;
}
.w1200 .channel-r .nodeImg {
  border: 1px solid #eee;
  border-radius: 7px;
  height: 82px;
  margin: 0 10px;
  position: relative;
  width: 82px;
}
.w1200 .channel-r .nodeImg img {
  border-radius: 7px;
  /* height: 80px; */
  width: 70px;
  position: absolute;
  top:50%;
  left:50%;
  transform:translate(-50%,-50%);
}
.w1200 .channel-r .left-top {
  display: inline-block;
  margin-left: 2px;
  margin-top: 2px;
  position: absolute;
  top: 0;
  left: 0;
}
.w1200 .channel-r .catNodes .node-title {
  font-size: 12px;
  line-height: 16px;
  margin: 5px 7px;
  text-align: center;
}
.w1200 .channel-r .catNodes:hover .nodeImg {
  opacity: 0.9;
  filter: alpha(opacity=90);
  transition: opacity 0.2s ease-in-out 0s;
}
.w1200 .channel-r .catNodes:hover a {
  color: #5178b5;
}
.w1200 i.icon-category-hot {
  background-image: url(../../assets/images/hot1.png);
  background-repeat: no-repeat;
  width: 27px;
  height: 27px;
  background-position: -2px 0;
}
.luotitle {
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/view/classify/index.vue